import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../_services/api/auth.service';
import { LoginRequest } from '../../_models/auth/login-request.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  loginRequest: LoginRequest = {
    usernameOrEmail: '',
    password: ''
  };

  errorMessage: string = '';
  isLoading: boolean = false;
  showPassword: boolean = false;
  emailNotVerified: boolean = false;

  ngOnInit(): void {}

  onLogin(loginForm: NgForm): void {
    if (loginForm.invalid) {
      this.markFormGroupTouched(loginForm);
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.emailNotVerified = false;

    this.authService.login(this.loginRequest).subscribe({
      next: (response) => {       
        setTimeout(() => {          
          if (this.authService.isAdmin()) {
            this.router.navigate(['/admin/dashboard']); 
          } else {
            this.router.navigate(['/member/profile']); 
          }
        }, 100);
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        
        if (error.status === 401) {
          const errorMessage = error.error?.message || '';
          if (errorMessage.includes('email') && errorMessage.includes('vérifiée')) {
            this.errorMessage = 'Votre adresse e-mail n\'est pas vérifiée. Veuillez vérifier votre boîte de réception.';
            this.emailNotVerified = true;
          } else {
            this.errorMessage = 'Nom d\'utilisateur ou mot de passe incorrect.';
          }
        } else if (error.status === 403) {
          this.errorMessage = 'Accès refusé. Veuillez vérifier vos informations.';
        } else {
          this.errorMessage = 'Une erreur est survenue. Veuillez réessayer plus tard.';
        }
      }
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  resendVerification(): void {
    if (!this.loginRequest.usernameOrEmail) {
      this.errorMessage = 'Veuillez entrer votre email pour renvoyer le lien de vérification.';
      return;
    }

    this.authService.resendVerification(this.loginRequest.usernameOrEmail).subscribe({
      next: () => {
        this.errorMessage = 'Lien de vérification envoyé avec succès!';
        this.emailNotVerified = false;
      },
      error: () => {
        this.errorMessage = 'Erreur lors de l\'envoi du lien de vérification.';
      }
    });
  }

  private markFormGroupTouched(formGroup: NgForm): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      control.markAsTouched();
    });
  }

  navigateToResendVerification(): void {
    if (this.loginRequest.usernameOrEmail) {
      this.router.navigate(['/resend-verification'], { 
        queryParams: { email: this.loginRequest.usernameOrEmail } 
      });
    } else {
      this.router.navigate(['/resend-verification']);
    }
  }
}